import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService, UtilsString, } from '@pit/core';

@Injectable()
export class HttpInterceptorAuthBasic implements HttpInterceptor {

  constructor(private configService: ConfigService) {
  }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if ((this.configService.configAuth.useAuth === true) &&
      (UtilsString.stringIsNullOrEmpty(this.configService.configAuth.authUserName) === false) &&
      (UtilsString.stringIsNullOrEmpty(this.configService.configAuth.authPassword) === false)) {
      const req = request.clone({
        headers: request.headers.set('Authorization', 'Basic ' + btoa(UtilsString.stringFormat('{0}:{1}', this.configService.configAuth.authUserName, this.configService.configAuth.authPassword)))
      });
      return next.handle(req);
    } else {
      return next.handle(request);
    }
  }

}
